//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2025, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */
const home = () => import("../components/home.vue");
const brandbar = () => import("../components/brandbar.vue");
const brandbar_admin = () => import("../components/brandbar_admin.vue");
const nibrs_review_form = () => import("../components/nibrs_review_form.vue");
const admin = () => import("../components/admin.vue");

const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  {
    name: "home",
    path: "/",
    component: home,
    display: "home",
  },
  {
    name: "brandbar",
    path: "/brandbar",
    component: brandbar,
    display: "brandbar",
  },

  {
    name: "brandbar_admin",
    path: "/brandbar_admin",
    component: brandbar_admin,
    display: "brandbar_admin",
  },

  {
    name: "nibrs_review_form",
    path: "/nibrs_review_form",
    component: nibrs_review_form,
    display: "nibrs_review_form",
  },

  {
    name: "admin",
    path: "/admin",
    component: admin,
    display: "admin",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
